import axios from 'axios';
import baseUrl from 'Base_Url/baseUrl';

export const FASTAPI_BASE_URL = 'https://atbc.aquasense.tech/api';

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

// Fetch product IDs from Node backend exactly as in previous code
export async function fetchPumpIds(signal) {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${baseUrl}/device/product-ids`, {
      headers: { Authorization: `Bearer ${token}` },
      signal,
    });

    const idsArray = response.data?.data?.data || response.data?.data || [];

    if (Array.isArray(idsArray) && idsArray.length > 0) {
      return idsArray.map(String).filter(Boolean);
    }
    throw new ApiError('No product IDs found.');
  } catch (err) {
    throw new ApiError(
      err.response?.data?.message || err.message || 'Failed to fetch product IDs.',
      err.response?.status
    );
  }
}

// Fetch dashboard telemetry from FastAPI exactly as in frontend - Copy
export async function fetchDashboard(pumpId, signal) {
  if (!pumpId) {
    throw new ApiError('No pump ID provided.');
  }

  try {
    const response = await axios.get(
      `${FASTAPI_BASE_URL}/pumps/${encodeURIComponent(pumpId)}/dashboard?refresh=true&include_details=true`,
      {
        headers: { Accept: 'application/json' },
        signal,
        timeout: 45000,
      }
    );

    const payload = response.data?.data || response.data;
    if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
      if (typeof payload.state !== 'string' || payload.state.trim() === '') {
        throw new ApiError('Dashboard response did not include a valid state.');
      }
      return payload;
    }
    throw new ApiError('Dashboard response was not a valid object.');
  } catch (err) {
    if (err instanceof ApiError) throw err;
    throw new ApiError(
      err.response?.data?.message || err.message || 'PumpWatch API is unavailable.',
      err.response?.status
    );
  }
}

// Reinitialize pump via FastAPI admin endpoint (POST /api/admin/pumps/{pump_id}/reinitialize)
export async function reinitializePump(pumpId, signal) {
  if (!pumpId) {
    throw new ApiError('No pump ID provided.');
  }

  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${FASTAPI_BASE_URL}/admin/pumps/${encodeURIComponent(pumpId)}/reinitialize`,
      {},
      {
        headers: {
          Accept: 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        signal,
        timeout: 45000,
      }
    );

    return response.data;
  } catch (err) {
    if (err instanceof ApiError) throw err;
    throw new ApiError(
      err.response?.data?.detail ||
        err.response?.data?.message ||
        err.message ||
        'Failed to reinitialize pump.',
      err.response?.status
    );
  }
}
